<template>
  <div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
      v-loading="loading">
      <el-form-item label="项目名称" prop="projectName" style="width:500px;">
        <el-input v-model="ruleForm.projectName" size='mini' maxlength="10" show-word-limit
          placeholder="请输入项目名称"></el-input>
      </el-form-item>
      <!-- <el-form-item label="所属账户" prop="account" style="width:500px;">
                <el-select v-model="ruleForm.account" size='mini' @change="accountChange" filterable placeholder="请选择">
                    <el-option
                    v-for="(item,index) in accountList"
                    :key="index"
                    :label="item.advertiser_account"
                    :value="item.advertiser_account">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属账户ID" prop="account" style="width:500px;">
                <el-input v-model="ruleForm.accountID" size='mini' :disabled="true" placeholder="请选择所属账户"></el-input>
            </el-form-item>
            <el-form-item label="所属月份" prop="month" style="width:500px;">
                <el-select v-model="ruleForm.month" size='mini' :disabled="ruleForm.account?false:true" filterable placeholder="请选择">
                    <el-option
                    v-for="(item,index) in monthList"
                    :key="index"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
                <span class="hint">其他月份账户金额未配置<br/>前往【账号配置】配置</span>
            </el-form-item>
            <el-form-item label="签约公司" prop="accountCompany" style="width:500px;">
                <el-input v-model="ruleForm.accountCompany" size='mini' placeholder="请输入签约公司"></el-input>
            </el-form-item>
            <el-form-item label="销售人员" prop="sale" style="width:500px;">
                <el-select v-model="ruleForm.sale" size='mini' filterable placeholder="请选择">
                    <el-option
                    v-for="(item,index) in saleList"
                    :key="index"
                    :label="item.real_name"
                    :value="item.real_name">
                    </el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="经手人" prop="manager" style="width:500px;">
                <el-input v-model="ruleForm.manager" size='mini' placeholder="请输入经手人"></el-input>
            </el-form-item>
            <el-form-item label="客户全称" prop="customer" style="width:500px;">
                <el-input v-model="ruleForm.customer" size='mini' placeholder="请输入客户全称"></el-input>
            </el-form-item>
            <el-form-item label="投放平台" prop="platform" style="width:500px;">
                <el-select v-model="ruleForm.platform" size='mini' filterable placeholder="请选择">
                    <el-option
                    v-for="(item,index) in platformList"
                    :key="index"
                    :label="item.platform_name"
                    :value="item.platform_name">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="媒体名称" prop="media" style="width:500px;">
                <el-select v-model="ruleForm.media" size='mini' filterable placeholder="请选择">
                    <el-option
                    v-for="(item,index) in mediaList"
                    :key="index"
                    :label="item.media_name"
                    :value="item.media_name">
                    </el-option>
                </el-select>
            </el-form-item> -->

    </el-form>
    <div slot="footer" style="text-align: center;">
      <el-button size='small' @click="resetForm('ruleForm')">取 消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')" size='small'>确 定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['operationProject'],
  data () {
    return {
      ruleForm: {
        projectName: this.operationProject.title ? this.operationProject.title : '',
        // account: this.operationProject.advertiser_account?this.operationProject.advertiser_account:'',
        // accountID: this.operationProject.advertiser_id?this.operationProject.advertiser_id:'',
        // accountCompany: this.operationProject.company?this.operationProject.company:'',
        // month: this.operationProject.month?this.operationProject.month:'',
        // sale: this.operationProject.sales_name?this.operationProject.sales_name:'',
        // manager: this.operationProject.handle_user?this.operationProject.handle_user:'',
        // customer: this.operationProject.customer_name?this.operationProject.customer_name:'',
        // platform: this.operationProject.platform_name?this.operationProject.platform_name:'',
        // media: this.operationProject.media_name?this.operationProject.media_name:''
      },
      rules: {
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
        ],
        // account: [
        //     { required: true, message: '请选择所属账户', trigger: 'change' },
        // ],
        // month: [
        //     { required: true, message: '请选择所属月份', trigger: 'change' },
        // ],
        // sale: [
        //     { required: true, message: '请输入销售人员', trigger: 'change' },
        // ],
        // manager: [
        //     { required: true, message: '请输入经手人', trigger: 'blur' },
        // ],
        // customer: [
        //     { required: true, message: '请输入客户全称', trigger: 'blur' },
        // ],
        // accountCompany: [
        //     { required: true, message: '请输入签约公司', trigger: 'blur' },
        // ],
        // platform: [
        //     { required: true, message: '请选择平台', trigger: 'change' },
        // ],
        // media: [
        //     { required: true, message: '请选择媒体', trigger: 'change' },
        // ],
      },
      accountList: [],
      platformList: [],
      mediaList: [],
      monthList: [],
      loading: false,
      saleList: []
    }
  },
  created () {
    // this.getSaleList();
    // this.accountsListEvent();
    // this.platformListEvent()
    // this.mediaListEvent()
  },
  methods: {
    // getSaleList(){
    //    this.$axios.get(this.URL.BASEURL + this.URL.users,{
    //        params:{
    //            page: 1,
    //            page_size: 999,
    //            role_id: 11
    //        }
    //     }).then((res) => {
    //         var res=res.data;
    //         this.loading = false;
    //         if(res&& res.errno == 0){
    //             var arr = res.rst.data;
    //             this.saleList = arr.filter((v)=>{
    //                 return v.real_name
    //             })
    //         }else {
    //             this.$message({
    //                 message: res.err,
    //                 type: 'warning'
    //             })
    //         }
    //     }).catch(()=>{
    //     })
    // },
    // accountsListEvent(){//账户列表
    //    this.$axios.get(this.URL.BASEURL + this.URL.accountSelect,{
    //     }).then((res) => {
    //         var res=res.data;
    //         if(res&& res.errno == 0){
    //             this.accountList = res.rst;
    //         }else {
    //             this.$message({
    //                 message: res.err,
    //                 type: 'warning'
    //             })
    //         }
    //     }).catch(()=>{
    //     })
    // },
    // accountChange(val){
    //     this.ruleForm.month = ''
    //     var arr = this.accountList.filter((v)=>{
    //         return v.advertiser_account == val;
    //     })
    //     this.ruleForm.accountID = arr[0].advertiser_id;
    //     this.monthList = arr[0].month;
    // },
    // platformListEvent(){//平台列表
    //    this.$axios.get(this.URL.BASEURL + this.URL.platformList,{
    //        params:{
    //            page: 1,
    //            page_size: 999,
    //        }
    //     }).then((res) => {
    //         var res=res.data;
    //         if(res&& res.errno == 0){
    //             this.platformList = res.rst.data;
    //             this.platformList.forEach((item) => {
    //                 if(item.is_default == 1){
    //                     this.ruleForm.platform = item.platform_name
    //                 }
    //             });
    //         }else {
    //             this.$message({
    //                 message: res.err,
    //                 type: 'warning'
    //             })
    //         }
    //     }).catch(()=>{
    //     })
    // },
    // mediaListEvent(){//媒体列表
    //    this.$axios.get(this.URL.BASEURL + this.URL.mediaList,{
    //        params:{
    //            page: 1,
    //            page_size: 999,
    //        }
    //     }).then((res) => {
    //         var res=res.data;
    //         if(res&& res.errno == 0){
    //             this.mediaList = res.rst.data;
    //             this.mediaList.forEach((item) => {
    //                 if(item.is_default == 1){
    //                     this.ruleForm.media = item.media_name
    //                 }
    //             });
    //         }else {
    //             this.$message({
    //                 message: res.err,
    //                 type: 'warning'
    //             })
    //         }
    //     }).catch(()=>{
    //     })
    // },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.projectAdd(formName)
        } else {
          return false;
        }
      });
    },
    projectAdd (formName) {//添加项目
      var axios_name = '';
      var data = {
        title: this.ruleForm.projectName,
        //    advertiser_account: this.ruleForm.account,
        //    advertiser_id: this.ruleForm.accountID,
        //    company: this.ruleForm.accountCompany,
        //    month: this.ruleForm.month,
        //    sales_name: this.ruleForm.sale,
        //    handle_user: this.ruleForm.manager,
        //    customer_name: this.ruleForm.customer,
        //    platform_name: this.ruleForm.platform,
        //    media_name: this.ruleForm.media,
      }
      // if(this.operationProject.id){//修改项目
      //     axios_name = this.URL.projectUpdate
      //     data.id = this.operationProject.id
      // }else{//添加项目
      axios_name = this.URL.projectAdd
      // }

      this.loading = true;
      this.$axios.post(this.URL.BASEURL + axios_name, data).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.$refs[formName].resetFields();
          this.$emit('rmit_updateList')
          this.$message({
            message: this.operationProject.id ? '修改成功！' : '添加成功！',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false;
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
      this.$emit('emit_closeToast')
    }
  }
}
</script>
<style lang="scss" scoped>
.hint {
  font-size: 12px;
  display: inline-block;
  width: 50%;
  line-height: 17px;
  vertical-align: middle;
  padding-left: 10px;
  color: #ea853c;
}
</style>



// WEBPACK FOOTER //
// src/components/disposeAdmin/project/addNewProject.vue